import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'
import { Card, type CardProps } from '../Card/Card'

export interface MessageCardProps extends CardProps {
  variant?: 'default' | 'warning' | 'error' | 'success' | 'upsell' | 'loading' | 'table'
}

export const MessageCard = styled(Card, {
  shouldForwardProp: youShallNotPass('variant'),
})<MessageCardProps>(({ theme, variant = 'default' }) => ({
  ...(variant === 'warning' && {
    backgroundColor: theme.tokens.ThemeColorCommonWarningContainer,
    color: theme.tokens.ThemeColorCommonOnWarningContainer,
  }),
  ...(variant === 'error' && {
    backgroundColor: theme.tokens.ThemeColorCommonErrorContainer,
    color: theme.tokens.ThemeColorCommonOnErrorContainer,
  }),
  ...(variant === 'upsell' && {
    backgroundColor: theme.tokens.ThemeColorCommonSecondaryContainer,
    color: theme.tokens.ThemeColorCommonOnPrimaryContainer,
  }),
  ...(variant === 'success' && {
    backgroundColor: theme.tokens.ThemeColorCommonSuccessContainer,
    color: theme.tokens.ThemeColorCommonOnSuccessContainer,
  }),
  ...(variant === 'loading' && {
    backgroundColor: theme.tokens.ThemeColorCommonBackground,
    color: theme.tokens.ThemeColorCommonOnSurfaceSecondary,
  }),
  // TODO(STL-2343): Replace inline values with design tokens once STL-2342 lands
  // Figma vars: border = --banner-color-info-outline, background = --banner-color-info-container
  ...(variant === 'table' && {
    border: '1px solid rgba(255, 255, 255, 0.00)',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  }),
}))
